import React from 'react';

const notImplemented = () => {
    throw new Error('method not implemented');
}

export interface VacationReportSearchContext {
    value: string;
    change: (value: string) => void;
}

export const initialState: VacationReportSearchContext = {
    value: '',
    change: notImplemented,
}

export const VacationReportSearchContext = React.createContext<VacationReportSearchContext>(initialState);